import SocureIcon from "src/assets/SocureIcon.svg?react";
import {
  getDefaultSocureComplianceBundle,
  getDefaultSocurePremiumBundle,
  getDefaultSocureStandardBundle,
} from "src/connections/connectionConfigs/socure/deprecatedSocureResources";
import {
  getDefaultSocureDigitalIntelligence,
  getDefaultSocureDocVPlusBundle,
  getDefaultSocureFraudBundle1,
  getDefaultSocureFraudBundle2,
  getDefaultSocureFraudBundle3,
  getDefaultSocureFraudBundle4,
  getDefaultSocureFraudBundle5,
} from "src/connections/connectionConfigs/socure/socureResources";
import { SocureTemplate } from "src/connections/connectionConfigs/socure/socureTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const SOCURE_CONFIG: ConnectionConfig<"socure"> = {
  icon: SocureIcon,
  description:
    "Accurate fraud detection and identity verification in real time",
  template: SocureTemplate,
  name: "Socure",
  resources: {
    // New bundles
    socure_fraud_bundle_1: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-1-full-fraud-suite",
      integrationResource: getDefaultSocureFraudBundle1,
    },
    socure_fraud_bundle_2: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-2-full-fraud-suite--address--kyc",
      integrationResource: getDefaultSocureFraudBundle2,
    },
    socure_fraud_bundle_3: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-3-full-fraud-suite--address--kyc--watchlist-standard",
      integrationResource: getDefaultSocureFraudBundle3,
    },
    socure_fraud_bundle_4: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-4-full-fraud-suite--address--kyc--watchlist-plus",
      integrationResource: getDefaultSocureFraudBundle4,
    },
    socure_fraud_bundle_5: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-5-full-fraud-suite--address--kyc--watchlist-premier",
      integrationResource: getDefaultSocureFraudBundle5,
    },
    socure_doc_v_plus_bundle: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#bundle-6-docv-plus-document-verification--device-risk",
      integrationResource: getDefaultSocureDocVPlusBundle,
    },
    socure_digital_intelligence: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/socure#digital-intelligence-report",
      integrationResource: getDefaultSocureDigitalIntelligence,
    },
    // Deprecated bundles
    compliance_bundle: {
      externalLink: null,
      integrationResource: getDefaultSocureComplianceBundle,
    },
    standard_bundle: {
      externalLink: null,
      integrationResource: getDefaultSocureStandardBundle,
    },
    premium_bundle: {
      externalLink: null,
      integrationResource: getDefaultSocurePremiumBundle,
    },
  },
};
